export const USER_FIELD_TYPE = 'com.atlassian.jira.user.ApplicationUser';
export const TEAM_FIELD_TYPE = 'com.atlassian.jira.teams.TeamId';
